import { useEffect } from 'react'
import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

import CreateImg from 'assets/illustration-filter.svg'
import ImportImg from 'assets/illustration-import.svg'

import { Button, Text } from 'components'

import { colors } from 'utils/colors'
import { useAppDispatch, useAppSelector } from 'store'
import { getUserPermission } from 'services/user'
import { ROUTES } from '../../../../constants/constants'

const EmptyLeadView = () => {
  const navigate = useNavigate()
  const {
    user: { userPermissions },
  } = useAppSelector((state) => state)

  const dispatch = useAppDispatch()

  useEffect(() => {
    if (userPermissions.status === 'UN_SET') {
      dispatch(getUserPermission())
    } // Todo: Use permissions from login response and remove unnecessary fetching of permissions (CRM2-1718)
  }, []) //eslint-disable-line react-hooks/exhaustive-deps

  return (
    <EmptyLeadWrapper>
      <Text color="gray5" fontSize={16} fontWeight="medium" mb={25} width="auto">
        There is no lead available yet, start your sale now!
      </Text>
      <OptionsWrapper>
        <Option>
          <OptionTitle>Create new leads</OptionTitle>
          <OptionSubtitle>Create your own sales list in a simple way.</OptionSubtitle>
          <CreateLeadImg />
          {userPermissions.status === 'SUCCESS' && userPermissions.data.accountWorkflow?.canCreate && (
            <Button inline icon="plus" onClick={() => navigate(`/${ROUTES.NEW_LEAD}`)} width="auto">
              New lead
            </Button>
          )}
        </Option>
        <Option>
          <OptionTitle>Import leads</OptionTitle>
          <OptionSubtitle>Import leads into your CRM from csv, excel files.</OptionSubtitle>
          <ImportLeadImg />
          <Button
            inline
            icon={['far', 'file-export']}
            onClick={() =>
              navigate(`/${ROUTES.LEADS_IMPORT}`, {
                state: { importType: 'leads' },
              })
            }
            variant="outline"
            width="auto"
          >
            Import
          </Button>
        </Option>
      </OptionsWrapper>
    </EmptyLeadWrapper>
  )
}

const CreateLeadImg = styled(CreateImg)`
  display: block;
  height: 100%;
  margin: auto;
`

const ImportLeadImg = styled(ImportImg)`
  display: block;
  margin: auto;
`

const EmptyLeadWrapper = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 450px;
  width: 100%;
`

const Option = styled.div`
  align-items: center;
  border: 1px dashed ${colors.gray5};
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 8px;
  padding: 35px 35px;
  width: 460px;
  gap: 0.5rem;
`

const OptionSubtitle = styled((p) => <Text {...p} />)`
  ${(p) => p.theme.font({ color: 'gray5', size: 14, weight: 'normal' })};
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
`

const OptionTitle = styled((p) => <Text {...p} />)`
  ${(p) => p.theme.font({ color: 'gray8', size: 16, weight: 'medium' })};
  height: 24px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  width: 124px;
`

const OptionsWrapper = styled.section`
  display: flex;
`

export default EmptyLeadView
